// @ts-nocheck

import { createSelector } from 'reselect';

import { getHistoryFromProps } from '../../selectors/_propsGetters_';
import { selectEntitiesCalendarEntity } from '../../selectors/entities/calendar/entitiesCalendarPrimary.selector';
import { selectEntitiesSportIds } from '../../selectors/entities/sportIds/entitiesSportIdsPrimary.selector';
import { selectEntitiesSports } from '../../selectors/entities/sports/entitiesSportsPrimary.selector';
import { selectCalendarMatchesEntities } from '../../selectors/route.selector';
import { selectUserCalendarPrefs } from '../../selectors/user/userPrimary.selector';
import { MatchEntity } from '../../states/entities/matches';
import { getFacetsSports } from '../../utils/facets';
import { getPreviousMatchId } from '../../utils/history';
import { createShallowEqualSelector } from '../../utils/reselect';

const emptyArray: [] = [];

const selectViewData = createSelector(
  [selectEntitiesCalendarEntity, selectCalendarMatchesEntities],
  (entities, matches) => {
    return {
      isLoading: entities === undefined || (entities && entities.matches === undefined),
      isNull: entities === null || (entities && entities.matches === null) || false,
      matches,
    };
  },
);

const selectRouteCalendarSelector = createShallowEqualSelector(
  [selectViewData, selectUserCalendarPrefs, selectEntitiesSportIds, selectEntitiesSports, getHistoryFromProps],
  ({ matches, isLoading, isNull }, prefs, sportIds, sports, history) => {
    if (isLoading || isNull) {
      return {
        list: emptyArray,
        isEmpty: matches.length === 0,
        prefs,
        isLoading,
        isNull,
      };
    }

    const wtvOnly = prefs?.filters?.wtvOnly ?? false;
    const facets = getFacetsSports(matches, sportIds, sports);
    let filteredMatches = matches;

    if (prefs) {
      const { sportIds: filtersSportIds = {} } = prefs.filters;

      // Si au moins un filtre de sport est selectionné, on filtre les matchs
      if (Object.values(filtersSportIds).some(Boolean)) {
        filteredMatches = matches.filter((match) => filtersSportIds[match.sportId]);
      }
    }

    // On filtre les matchs qui ne sont pas de la winatv si l'option wtvOnly est activée
    const list = filteredMatches.filter((match) => (wtvOnly && MatchEntity.isWinamaxTvChannel(match)) || !wtvOnly);

    return {
      list,
      isEmpty: list.length === 0,
      isLoading,
      isNull,
      facets,
      prefs,
      anchorMatchId: getPreviousMatchId(history),
    };
  },
);

export default selectRouteCalendarSelector;
